import React from "react";
import "./App.css";
import { MenuProvider } from "./context/MenuContext";
import MainPage from "./MainPage";
import { LoaderProvider } from "./context/LoaderContext";
import MetaTags from "./utils/MetaTags";
import { ManagerProvider } from "./context/HomeContext";
import { BrowserRouter } from "react-router-dom";
import {
  GalleryBannerProvider,
  GalleryImageProvider,
} from "./context/GalleryContext";
import { CompanyDetailsProvider } from "./context/CompanyDetailsContext";
import { RoomContextProvider } from "./context/RoomContext";
import { useToast } from "./hooks/useToast";

const App = () => {
  return (
    <>
      <MetaTags />
      <RoomContextProvider>
      <CompanyDetailsProvider>
        <GalleryImageProvider>
          <GalleryBannerProvider>
            <ManagerProvider>
              <LoaderProvider>
                <MenuProvider>
                  <BrowserRouter>
                    <MainPage />
                  </BrowserRouter>
                </MenuProvider>
              </LoaderProvider>
            </ManagerProvider>
          </GalleryBannerProvider>
        </GalleryImageProvider>
      </CompanyDetailsProvider>
      </RoomContextProvider>
      {useToast()}
    </>
  );
};

export default App;
